import {css} from 'styled-components';

// `overflow-wrap: anywhere` breaks unbreakable tokens (e.g. long URLs) and lets them
// count toward min-content size, enabling `minmax(0, 1fr)` grid tracks to shrink.
// `word-break: break-word` is a defensive fallback for older engines.
export const wrapLongText = css`
	overflow-wrap: anywhere;
	word-break: break-word;
`;
